<template lang="pug">
.wrapper
    .container.m-auto
        HeaderGlobal(HeaderGlobalHeading="Target" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading {{ page_title }}
                    .header-cta
                    //- router-link.btn-primary-o(to="/target")
                    button.btn-default(@click="back()")
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg> 
                        span.ml-2 Back
            .box__body
                .box__body
                    .container-form(action="" method="method")
                        //- section target spesifict
                        section.group-fields.border-b
                            .field
                                .box-photo-container.w-full(v-if="faceapiLoaded")
                                    .relative.mt-5.mb-5(v-if="load_data_status_single_target_detail === 'loading'")
                                        .field-style.flex.flex-wrap.items-center.justify-center.p-2
                                            Spinner(show="true" size="48")
                                    //- template(v-if="imagesTarget.length > 0")
                                    template(v-else-if="photos.length > 0")
                                        label.block.text-sm.font-bold Target's Photos Selected
                                        ul.grid.grid-cols-3.gap-8.box-photo
                                            //- li.box-photo__item(v-for="(image, index) in imagesTarget")
                                            li.box-photo__item(v-for="(image, index) in photos")
                                                .border.item-photo
                                                    .flex.w-full.h-full.flex-wrap.bg-white.opacity-50.items-center.justify-center.absolute(:id="`photo-load-${index}`")
                                                        Spinner(show="true" size="48")

                                                    img.w-full.h-full.object-cover(:src="image.file?image.file:image" @error="getDefaultImage" :ref="`photo-${index}`" :id="`photo-${index}`"
                                                        @load="detectFace(index)" crossorigin="anonymous")

                                                    button.btn-icon-40.btn-delete.bg-white( @click="removeImage(index)")
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                                            li.box-photo__item
                                                .border.item-photo
                                                    .added-photo
                                                        .added-photo__cta
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                                            span Add Photo
                                                        .added-photo__input 
                                                            input(ref="imageInput" type="file"  @change="onFileChange" accept="image/png, image/jpeg")
                                                            //- input( multiple type="file"  @change="onFileChange" accept="image/png, image/jpeg")
                                    template(v-else)
                                        .cta-select.border.p-8
                                            .cta-select__ui.text-center
                                                .inline-block
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                                                p Please selects target's photos
                                            .cta-select__input
                                                input(ref="imageInput" type="file"  @change="onFileChange" accept="image/png, image/jpeg")
                                                //- input( multiple type="file"  @change="onFileChange" accept="image/png, image/jpeg")

                                .relative.w-full(v-else)
                                    .field-style
                                        .field-style--loading.flex.w-full.h-full.items-center.justify-center
                                            Spinner(show="true" size="64")
                        section.group-fields.border-b
                            //- name
                            //- .preview-avatar.relative.w-32.m-auto.mb-2
                                img(:src="photo" @error="getDefaultImage").w-32.h-32.object-cover.rounded-full.border.mx-auto
                                button.flex.items-center.justify-center.change-image.absolute.w-12.h-12.rounded-full.bg-gray-200.bottom-0.right-0.pointer
                                    input(type="file" @change="changeImgAvatar" accept="image/png, image/jpeg")
                                    span.text-gray-600
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-camera"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
                            //- .flex.items-center.justify-center.mb-2
                                .error.text-xs(v-if="error_photo !== null") {{ error_photo }}

                            .field
                                .field__label
                                    label.block.text-sm.font-bold.mb-2(for="target_name") Target Name *
                                .field__form
                                    input.field-style(id="target_name" name="target_name" type="text" placeholder="Write Target Name" v-model="target_name" maxlength="255")
                                    .error.absolute.pt-1.text-xs(v-if="error_target_name !== null") {{ error_target_name }}
                                
                            //- colors
                            //- .field.flex.items-center.w-full.-mx-4.mb-6
                                div.px-4(class="w-1/3").text-right
                                    label.block.text-sm.font-bold.mb-2(for="label") Label Color *
                                div.px-4(class="w-2/3")
                                    ul.flex.items-center(name="label" v-model="label")
                                        li.mr-2(v-for="opt in labelOpt" :key="opt.key" :value="opt.key" @click="selectLabel(opt.key)")
                                            div.box-label.p-1.border.rounded-full(:class="label === opt.key ? 'border-white-900':'border-gray-200'")
                                                label(:class="[`block w-6 h-6 bg-${opt.key}-500 rounded-full`]")
                                        template(v-if="error_label !== null")
                                            li
                                                .error.pt-1.text-xs {{ error_label }} 
                            //- colors
                            .field
                                .field__label
                                    label.block.text-sm.font-bold.mb-2(for="label") Label Color *
                                .field__form
                                    .main-color-picker
                                        color-picker(v-model="labelValue" @input="onColorPicker")
                                    .error.pt-1.text-xs {{ error_label }}
                            
                            //- case name
                            .field
                                .field__label
                                    label.block.text-sm.font-bold.mb-2(for="case_id") Operation Name *    
                                .field__form
                                    .relative(v-if="load_data_status_case_management_list === 'loading'")
                                        .field-style.flex.flex-wrap.items-center.justify-center.p-2
                                            Spinner(show="true" size="32")
                                    .relative(v-else)
                                        multiselect(
                                            v-if="case_management_list.data && case_management_list.data.length > 0"
                                            :value="casesValue",
                                            :options="case_management_list.data ? case_management_list.data : []",
                                            :multiple="true",
                                            placeholder="Select Case",
                                            label="operation_name",
                                            track-by="id",
                                            @input="onChange"
                                        )

                                        .field.field--disabled(v-else)
                                            input.field-style(type="text" placeholder="Case empty" disabled)
                                    .error.absolute.pt-1.text-xs(v-if="error_case_id !== null") {{ error_case_id }}
                                                                        
                        //-===== end section
                            
                        //- section target clues
                        section.group-fields.border-b
                            //- name
                            .field
                                .field__label
                                    label.block.text-sm.font-bold.mb-2.pt-2(for="field") Target's Clues *
                                .field__form
                                    .flex.items-end.w-full.mb-1(
                                        class="flex-col lg:flex-row lg:items-center"
                                    )
                                        .w-full(class="lg:w-1/3")
                                            .relative(
                                                class="mb-2 lg:mb-0"
                                            )
                                                select.field-style(name="clue-name-tmp" v-model="clueNameTmp")
                                                    option(selected disabled value='') - Select Option - 
                                                    option(v-for="opt in cluesOpt" :key="opt.key" :value="opt.key") {{ opt.name }}
                                                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2.text-gray-700
                                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                        .flex.pl-0.pb-2(
                                            class="lg:w-2/3 w-full lg:pl-2 flex-col lg:flex-row lg:pb-0"
                                            )
                                            input.field-style(
                                                id="clues-tmp"
                                                placeholder="Write Target's clue"
                                                v-model="clueValTmp"
                                                v-on:keyup.enter="addClue()"
                                                v-bind:type="clueNameTmp!='nopol'?'number':'text'"
                                            )
                                            .flex.ml-0.mt-4.justify-end(
                                                class="lg:ml-4 lg:mt-0"
                                            )
                                                button.btn-icon.btn-icon-40.btn-primary-o(
                                                    type='button'
                                                    @click="addClue()"
                                                )
                                                    .icon-btn
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                    .flex.items-center.w-full.mb-8
                                        .error.pt-1.text-xs.mr-2(v-if="error_clues !== null") {{ error_clues }}
                                        small.text-gray-600 * MSISDN Max: 3, Others Max: 1

                                    .w-full(v-if="clues.length > 0")
                                        .text-xs.uppercase.font-bold.mb-4 Added Clues
                                        .box--items
                                            .flex.items-start.flex-col.w-full.py-4.px-2.border-b.is-item(
                                                v-for="(clue, index) in clues"
                                                :key="index"
                                                class="lg:flex-row"
                                            )
                                                .relative.w-full.mr-0.mb-4(
                                                    class="lg:mr-2 lg:mb-0 lg:w-65"
                                                )
                                                    select.field-style(v-model="clue.name" :key="index")
                                                        option(v-for="opt in cluesOpt" :value="opt.key" :selected="opt.key === clue.name ? 'selected' : ''") {{ opt.name }}
                                                    .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                                .relative.flex-grow.w-full
                                                    input.field-style(v-bind:type="clue.name!='nopol'?'number':'text'" placeholder="Write Target's clue" v-model="clue.value" :key="index")
                                                    template(v-if="clue.name == 'msisdn'" v-for="(detail,key) in clue.detail")
                                                        .flex.items-center.mt-1
                                                            input.field-style(type='number' v-bind:placeholder="(detail.name).toUpperCase()" v-model="detail.value" v-bind:key="key")
                                                button.btn-icon.ml-2(
                                                    type='button'
                                                    @click="deleteClue(index)"
                                                    style="margin-top:4px")
                                                    .icon-btn
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                        //-===== end section

                        //- section Additional info
                        section.group-fields.border-b
                            //- name
                            .field
                                .field__label
                                    label.block.text-sm.font-bold.mb-2.pt-2(for="field") Additional Information
                                .field__form
                                    .flex.items-end.w-full.mb-1(
                                        class="flex-col lg:flex-row lg:items-center"
                                    )
                                        .w-full(class="lg:w-1/3")
                                            .relative(
                                                class="mb-2 lg:mb-0"
                                            )
                                                input.field-style(
                                                    id="info-name-tmp"
                                                    type="text"
                                                    placeholder="Write a Key"
                                                    name="info-name-tmp"
                                                    v-model="infoNameTmp"
                                                    v-on:keyup.enter="addInfo()"
                                                )
                                        .flex.pl-0.pb-2(
                                            class="lg:w-2/3 w-full lg:pl-2 flex-col lg:flex-row lg:pb-0"
                                        )
                                            input.field-style(
                                                id="info-val-name"
                                                type="text"
                                                placeholder="Write a Key's value"
                                                v-model="infoValTmp"
                                                v-on:keyup.enter="addInfo()"
                                                class="mb-2 lg:mb-0"
                                            )
                                            .flex.ml-0.mt-4.justify-end(
                                                class="lg:ml-4 lg:mt-0"
                                            )
                                                button.btn-icon.btn-icon-40.btn-primary-o(
                                                        type='button'
                                                        @click="addInfo()"
                                                )
                                                    .icon-btn
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                    .w-full(v-if="additional_info.length > 0")
                                        .text-xs.uppercase.font-bold.py-4 Added Additional Information
                                        .box--items
                                            .flex.items-center.w-full.py-4.px-2.border-b.is-item.is-item--keys(
                                                v-for="(info, index) in additional_info"
                                                :key="index"
                                                class="flex-col lg:flex-row"
                                            )
                                                .relative(
                                                    class="lg:mr-2 mr-0 w-full"
                                                )
                                                    input.field-style(v-model="info.name" :key="index" type="text" placeholder="Write")
                                                input.field-style(v-model="info.value" :key="index" type="text" placeholder="Write")
                                                button.btn-icon.ml-2(type='button' @click="deleteInfo(index)")
                                                    .icon-btn
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                                        
                            
                        //-===== end section

                        //- section target spesifict
                        section.group-fields.border-b
                            //- name
                            .field
                                .field__label
                                    label.block.text-sm.font-bold.mb-2(for="description") Description
                                .field__form
                                    textarea.field-style(id="description" name="description" v-model="description" style="min-height: 200px;" placeholder="Write Target's Description")
                                    .error(v-if="error_description !== null") {{ error_description }}

                        //-===== end section
                        .flex.items-center.justify-end.mb-8
                            //- button.btn-primary-o.mr-3 DRAFT
                            //- button.btn-primary SAVE
                            button.btn-default.btn-large.mr-3(type='button' @click="reset()")
                                Strong Reset
                            button.btn-primary-o.btn-large.mr-3(type='submit' @click="submit($event, true)")
                                Strong Save &amp; Continue
                            button.btn-primary.btn-large(type='submit' @click="submit")
                                Strong Save                 

    //- pop up face modal
    section.section-popup.fixed.w-full-h.full.bg-gray-100.inset-0.flex.items-start.justify-center(
        v-bind:class="{'section-popup--show' : selectFaceModal}"
    )
        .section-popup__container
            .box
                .box__header.no-border
                    header.flex.items-center.justify-between
                        span.text-light Please select face
                        .header-cta
                            button.btn-icon.btn-icon-40(@click="faceModal(false)")
                                .icon.btn
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                .box__body.p-4
                    .block.mb-10(v-if="faceDetected.length > 0")
                        //- h2 Found {{ faceDetected.length }} Objects
                        .box-object
                            button.list-object(
                                :class="{'list-object--active' : faceSelected===index}" 
                                v-for="(face, index) in faceDetected" 
                                @click="selectFace(index)"
                                :key="index"
                            )
                                img(:src="face", @error="getDefaultImage")

                    .pb-2
                        div.mb-2
                            .flex.items-center.justify-end
                                button.btn-primary-o.mr-4(@click="faceModal(false)") Cancel

                                template(v-if="faceSelected != null")
                                    button.btn-primary(type='submit' @click="selectAction()") Choose Face
                                    //- button.btn-primary(type='submit') Choose Face
                                //- msisdn belum dipilih
                                template(v-else)
                                    button.btn-primary.btn-disabled(type='button' disabled style="cursor: not-allowed; opacity: .4;") Choose Face
                                //- proses loading 
                                //- button.btn-primary.btn-disabled(type='submit' disabled)  Starting Monitoring...-events:none") Save

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue';
import Multiselect from 'vue-multiselect'
import { encrypt } from '@/util/crypto'
import { Slider } from 'vue-color'
import Spinner from '@/components/Spinner.vue';
import * as faceapi from "face-api.js";

export default {
    name: 'PageTargetForm',
    components: {
        HeaderGlobal,
        Multiselect,
        'color-picker': Slider,
        Spinner,
    },
    props: ['propTarget'],
    data: function() {
        return {
            value: null,
            options: ['list', 'of', 'options'],
            target_name: '',
            clues: [],
            label: '',
            // status: '',
            photo: '',
            photos: [],
            case_id: [],
            description: '',
            additional_info: [],
            //tmp
            // photoFile: '',
            photosFile: [],
            clueNameTmp: '',
            clueValTmp: '',
            infoNameTmp: '',
            infoValTmp: '',
            // error field
            error_target_name: '',
            error_clues: '',
            error_label: '',
            // error_status: '',
            error_photo: '',
            error_case_id: '',
            error_description: '',
            error_additional_info: '',

            imgAvatar: require('../../assets/no-image-profile.jpg'),

            labelOpt: [
                {key: 'green'},
                {key: 'red'},
                {key: 'purple'},
                {key: 'orange'},
                {key: 'blue'},
            ],

            // move to computed for astro
            // cluesOpt: [
            //     {key: 'msisdn',name: 'MSISDN'},
            //     {key: 'nik',name: 'NIK'},
            //     {key: 'imsi',name: 'IMSI'},
            //     {key: 'imei-sv',name: 'IMEI-SV'},
            //     {key: 'nopol',name: 'Plat Nomor'},
            // ]
            isAstro: process.env.VUE_APP_ASTRO,
            maxFile: this.$store.getters.getMaxImageSize,

            // faceDetected: [],
            faceDetected: [
                "/img/liberty.jpg",
                "/img/liberty.jpg",
                "/img/liberty.jpg",
                "/img/liberty.jpg",
            ],
            faceapiLoaded: false,
            selectFaceModal: false,
            faceSelected: null,
            photoIndex: null,
            ignoreFaceDetect: true,
        }
    },
    computed: {
        ...mapState([
            'single_target_detail',
            'load_data_status_single_target_detail',
            'load_data_status_case_management_list',
            'case_management_list',
            'target_redirect',
            // 'auth_data',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            return this.$route.params.id;
        },
        breadcrumb() {
            let page = {
                name: 'Edit Target',
                url: '/target/'+this.id+'/edit',
            };
            if (this.route_name === 'PageTargetCreate')
                page = {
                    name: 'Add Target',
                    url: '/target/create',
                };

            return [
                {
                    name: 'Target',
                    url: '/target',
                },
                page,
            ];
        },
        page_title() {
            let title = 'Edit Target';
            if (this.route_name === 'PageTargetCreate')
                title = 'Add Target';
            return title;
        },
        casesValue: {
            get() {
                if (!this.case_id) return null
                // console.log('=====onChange:get')
                // console.log(this.case_id)
                try {
                    return this.case_id.map(value => this.findOption(value.id)).filter(value => value.id)
                } catch (error) {
                    // console.log('error casesvalue')
                    // console.log(error)
                    return null
                }
            },
            set(v) {
                // console.log('=====casesValue:set')
                // console.log(v)
                this.case_id=v.map(value => {
                    let rObj = {}
                    rObj['id'] = value.id
                    return rObj
                })
            }
        },
        labelValue: {
            get() {
                if (!this.label) return ''
                // console.log('=====labelValue:get')
                // console.log(this.label)
                return {
                    hex:this.label
                }
            },
            set(v) {
                // console.log('=====labelValue:set')
                // console.log(v)
                this.label=v.hex
            }
        },
        cluesOpt() {
            let cluesOpt = [
                    {key: 'msisdn',name: 'MSISDN'},
                    {key: 'nik',name: 'NIK'},
                    {key: 'imsi',name: 'IMSI'},
                    {key: 'imei-sv',name: 'IMEI-SV'},
                    {key: 'nopol',name: 'Plat Nomor'},
                ];

            if (this.isAstro === 'true') {
                cluesOpt = [
                    {key: 'msisdn',name: 'MSISDN'},
                ];
            }

            return cluesOpt;
        },
    },
    watch: {
        // propTarget(newData) {
        //     console.log('propTarget')
        //     console.log(newData)
        // },
        route_name() {
            this.getData();
        },
        id() {},
        breadcrumb() {},
        page_title() {},
        // form data
        single_target_detail(newData) {
            // console.log('masuk watch single_target_detail')
            if (this.propTarget == undefined || this.propTarget.clues == undefined) {
                // console.log('masuk watch 2')
                this.target_name = (newData.target_name ? newData.target_name : '');
                this.clues = (newData.clues ? newData.clues : []);
            }
            this.label = (newData.label ? newData.label : '');
            // this.status = (newData.status ? (newData.status.toLowerCase() === 'start' ? '1' : '0') : '');
            // this.photo = (newData.photo ? newData.photo : '');
            this.case_id = (newData.case_id && newData.case_id ? newData.case_id : []);
            this.description = (newData.description ? newData.description : '');
            this.additional_info = (newData.additional_info ? newData.additional_info : []);
            
            if (newData.photos && newData.photos.length > 0) {
                this.photos = newData.photos;
                this.photosFile = [];
                for (let i = 0; i < newData.photos.length; i++) {
                    const url = newData.photos[i].file
                    const ext = url.split('.').pop();
                    const fileName = 'image'+i+'.'+ext
                    fetch(url)
                        .then(async response => {
                            const contentType = response.headers.get('content-type')
                            const blob = await response.blob()
                            const file = new File([blob], fileName, {
                                contentType
                            })
                            this.photosFile.push(file)
                            // access file here
                        })
                }
            } else {
                this.photos = [];
            }
        },

        target_name() {},
        clues() {},
        // load_data_status_case_management_list(newData) {
        //     if (newData === 'loading') {
        //         this.showLoading(true);
        //     } else {
        //         this.showLoading(false);
        //     }

        // },
        case_id() {},
        // status() {},
        additional_info() {},
        cluesOpt() {},
    },
    methods: {
        async processSearch(key, type='msisdn') {
            await this.$store.dispatch('setEmptyResultData', []);

            EventEmit.$emit('fromGlobalSearch');

            // search by name
            if (type === 'name') {
                this.$router.push({ name: 'PageName', params: { key: encrypt(key + '&&' + type) } });

            // check for astro
            } else if (this.isAstro === 'true') {
                this.$router.push({ name: 'result-recent-location', params: { key: encrypt(key + '&&' + type) } });

            } else if (type !== 'nopol') {
                let route_name = '';
                if (type === 'msisdn' || type === 'imsi' || type === 'imei-sv') {
                    route_name = 'result-recent-location';
                } else if (type === 'nik') {
                    route_name = 'result-profile';
                } else if (type === 'email') {
                    route_name = 'result-marketplace';
                }
                this.$router.push({ name: route_name, params: { key: encrypt(key + '&&' + type) } });
            } else {
                this.$router.push({ name: 'result-vehicles', params: { key: encrypt(key + '&&' + type) } });
            }
        },
        back(){
            if (this.propTarget && this.propTarget.decrypt_data) {
                this.$swal.fire({
                    icon: 'question',
                    title: 'You wanna go back to?',
                    // text: id,
                    confirmButtonText: 'Result',
                    confirmButtonColor: '#3085d6',
                    cancelButtonText: 'List Target',
                    cancelButtonColor: '#dd6b55',
                    showCancelButton: true,
                })
                    .then((result) => {
                        if (result.isConfirmed) { 
                            this.processSearch(this.propTarget.decrypt_data.key, this.propTarget.decrypt_data.type)
                        } else {
                            this.$router.push('/target');
                        }
                })
            } else {
                if (this.target_redirect !== 'index') {
                    var msisdn = this.checkMsisdn(this.clues)
                    if (msisdn.length > 0) {
                        this.$router.push({ name: 'PageTargetDetailHome', params: { id: this.id ,key: encrypt(msisdn[0].value + '&&msisdn') }  })
                    } else {
                        this.$router.push('/target');
                    }
                } else {
                    this.$router.push('/target');
                }
            }
        },
        checkMsisdn(data) {
            var msisdn = data.filter(function (clue) {
                return clue.name === 'msisdn'
            })
            return msisdn
        },
        onChange (value) {
            this.casesValue = value
        },
        onColorPicker(value) {
            this.labelValue = value
        },
        findOption(value) {
            // console.log('=====findOption')
            // console.log(value)
            const opt = this.case_management_list.data
            try {
                return opt.find(option => option['id'] === value)
            } catch (error) {
                // console.log('error')
                // console.log(error)
                return opt
            }
        },
        getDefaultImage(e) {
            e.target.src = this.imgAvatar;
        },
        getData() {
            // console.log('=================== getData() route on roles form')
            if (this.propTarget == undefined || this.propTarget.clues == undefined) {    
                this.target_name = '';
                this.clues = [];
            }
            this.label = '';
            // this.status = '';
            this.photo = '';
            this.case_id = [];
            this.description = '';
            this.additional_info = [];

            this.photoFile= '';
            this.photosFile= [];
            this.clueNameTmp= '';
            this.clueValTmp= '';
            this.infoNameTmp= '';
            this.infoValTmp= '';

            this.error_target_name = '';
            this.error_clues = '';
            this.error_label = '';
            // this.error_status = '';
            this.error_photo = '';
            this.error_case_id = '';
            this.error_description = '';
            this.error_additional_info = '';
            
            // get client list
            if (this.route_name === 'PageTargetEdit' || this.route_name === 'PageTargetCreate') {

                // temporary
                // this.$store.dispatch('getClientsList', [100, 1]);

                // after client_id is not used
                this.$store.dispatch('getCaseManagementList', [100, 1]);
            }

            if (this.route_name === 'PageTargetEdit') {
                // console.log(this.id);

                // for dispatch get data

                this.showLoading(true);

                this.$store.dispatch('getSingleTargetDetail', [this.id])
                .then((resp) => {
                    if (resp === 'success') {

                        this.showLoading(false);

                    } else {
                        this.error();
                    }
                });

            } else {
                if (this.route_name === 'PageTargetCreate')
                    this.$store.commit('setSingleTargetDetail', {});
            }
        },
        changeImgAvatar(e) {
            const file = e.target.files[0];
            if (file) {
                if (file.type === 'image/jpeg'||file.type === 'image/png') {
                    if (file.size > (this.maxFile * 1024 * 1024)) {
                        this.error_photo = 'File size not more than '+this.maxFile+' MB!';

                        var size = ((file.size/1024)/1024).toFixed(2);

                        if (document.getElementById('file'))
                            document.getElementById('file').value = '';

                        this.$swal.fire({
                            icon: 'error',
                            title: 'Failed!',
                            text: 'File size not more than '+this.maxFile+' MB! Your file size is '+ size +' MB.',
                        });

                    } else {
                        this.photoFile = file
                        this.photo = URL.createObjectURL(file);
                    }

                } else {
                    if (document.getElementById('file'))
                        document.getElementById('file').value = '';

                    this.error_photo = 'Only JPG/PNG is allowed!';

                    this.$swal.fire({
                        icon: 'error',
                        title: 'Failed!',
                        text: 'Only JPG/PNG is allowed!',
                    });
                }
            } else {
                this.file = null;
            }
        },
        
        // // FILE UPLOAD old HERE
        // onFileChange(e) {
        //     var files = e.target.files || e.dataTransfer.files;
        //     if (!files.length) return;
        //     this.createImage(files);
        // },
        // createImage(images) {
        //     for (var index = 0; index < images.length; index++) {
        //         const file = images[index];
        //         // const file = images[index].target.files[0];
        //         if (file) {
        //             if (file.type === 'image/jpeg'||file.type === 'image/png') {
        //                 if (file.size > (this.maxFile * 1024 * 1024)) {
        //                     this.error_photo = 'File size not more than '+this.maxFile+' MB!';

        //                     var size = ((file.size/1024)/1024).toFixed(2);

        //                     if (document.getElementById('file'))
        //                         document.getElementById('file').value = '';

        //                     this.$swal.fire({
        //                         icon: 'error',
        //                         title: 'Failed!',
        //                         text: 'File size not more than '+this.maxFile+' MB! Your file size is '+ size +' MB.',
        //                     });

        //                 } else {
        //                     this.photosFile.push(file)
        //                     this.photos.push(URL.createObjectURL(file))
        //                 }

        //             } else {
        //                 if (document.getElementById('file'))
        //                     document.getElementById('file').value = '';

        //                 this.error_photo = 'Only JPG/PNG is allowed!';

        //                 this.$swal.fire({
        //                     icon: 'error',
        //                     title: 'Failed!',
        //                     text: 'Only JPG/PNG is allowed!',
        //                 });
        //             }
        //         }
        //     }
        //     // this.photos = tmp
        // },
        // removeImage(index) {
        //     this.photos.splice(index, 1)
        //     this.photosFile.splice(index, 1)
        //     // this.imagesTarget.splice(index, 1)
        // },
        // // END FILE UPLOAD old HERE

        // FILE UPLOAD HERE
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            // EventEmit.$emit('showLoading', true);
            this.showLoading(true);

            this.ignoreFaceDetect = false
            
            try {
                var file = files[0];
            } catch (error) {
                return;
            }

            this.createImage(file);
        },
        async detectFace(index) {  
            let input = document.getElementById(`photo-${index}`);

            if (this.ignoreFaceDetect) {
                // EventEmit.$emit('showLoading', false);
                this.showLoading(false);
                const canvas = await faceapi.createCanvasFromMedia(this.$refs[`photo-${index}`][0])
                const displaySize = { width: input.width, height: input.height }
                await document.getElementById(`photo-${index}`).parentElement.prepend(canvas)
                await faceapi.matchDimensions(canvas, displaySize)
                // let fullFaceDescriptions = faceapi.resizeResults(detections, displaySize)
                // faceapi.draw.drawDetections(canvas, fullFaceDescriptions)
                // faceapi.draw.drawFaceLandmarks(canvas, fullFaceDescriptions)
                document.getElementById(`photo-load-${index}`).style.display='none';
                // document.getElementById(`photo-load-${index}`).style.display='none';
            } else {         
                // let input = this.$refs[`photo-${index}`][0];
                this.faceDetected = [];
                
                if (input){
                    const options = new faceapi.SsdMobilenetv1Options({
                        minConfidence: 0.3,
                        maxResults: 100,
                    })
                    let detections = await faceapi
                    .detectAllFaces(input, options)
                    .withFaceLandmarks()
                    .withFaceDescriptors();
                    let responseData = '';
                    if (detections && detections.length){
                        if (detections.length>1){
                            // console.log('lebih dari 1');
                            // cropface
                            // responseData = 'Picture should be contained only 1 face'
                            await detections.forEach((element, index) => {
                                // console.log(element)
                                this.cropFace(element.detection, index, input)
                            });
                            // show pilihan face
                            this.faceModal(true, index)
                        } else {
                            const canvas = faceapi.createCanvasFromMedia(this.$refs[`photo-${index}`][0])
                            const displaySize = { width: input.width, height: input.height }
                            document.getElementById(`photo-${index}`).parentElement.prepend(canvas)
                            faceapi.matchDimensions(canvas, displaySize)
                            // let fullFaceDescriptions = faceapi.resizeResults(detections, displaySize)
                            // faceapi.draw.drawDetections(canvas, fullFaceDescriptions)
                            // faceapi.draw.drawFaceLandmarks(canvas, fullFaceDescriptions)
                            document.getElementById(`photo-load-${index}`).style.display='none';
                        }
                    } else {
                        // console.log('tidak jelas')
                        responseData = 'Face is not detected in this picture'
                    }

                    if (responseData!=''){
                        this.$swal.fire({
                            icon: 'error',
                            title: 'Image Failed!',
                            text: responseData,
                        });
                        this.removeImage(index)
                    } else {
                        // EventEmit.$emit('showLoading', false);
                        this.showLoading(false);
                    }
                }
            }
            this.ignoreFaceDetect = true
        },
        async cropFace(detection, index, input) {
            let box = detection._box
            let regionsToExtract = []
            let defPixel = 5
            let addPixel = defPixel * Math.ceil(box._height/50)         
            try {
                regionsToExtract = [
                    new faceapi.Rect((box._x-addPixel*2), (box._y-(addPixel*2)), (box._width+(addPixel*4)), (box._height+(addPixel*3)))
                    // new faceapi.Rect((box._x), (box._y), (box._width), (box._height))
                ]
            } catch (error) {
                regionsToExtract = [
                    new faceapi.Rect((box._x), (box._y), (box._width), (box._height))
                ]
            }
            // let input = document.getElementById(`photo-${index}`);
            const face = await faceapi.extractFaces(input, regionsToExtract)
            let tmpFace = await face[0].toDataURL("image/jpeg", 1);
            this.faceDetected.push(tmpFace)
        },
        createImage(images) {
            const file = images

            if (file) {
                if (file.type === 'image/jpeg'||file.type === 'image/png') {
                    if (file.size > (this.maxFile * 1024 * 1024)) {
                        this.error_photo = 'File size not more than '+this.maxFile+' MB!';

                        var size = ((file.size/1024)/1024).toFixed(2);

                        if (document.getElementById('file'))
                            document.getElementById('file').value = '';

                        this.$swal.fire({
                            icon: 'error',
                            title: 'Failed!',
                            text: 'File size not more than '+this.maxFile+' MB! Your file size is '+ size +' MB.',
                        });

                    } else {
                        this.photosFile.push(file)
                        // this.model.photos.push(URL.createObjectURL(file))
                        this.photos.push(URL.createObjectURL(file))
                    }

                } else {
                    if (document.getElementById('file'))
                        document.getElementById('file').value = '';

                    this.error_photo = 'Only JPG/PNG is allowed!';

                    this.$swal.fire({
                        icon: 'error',
                        title: 'Failed!',
                        text: 'Only JPG/PNG is allowed!',
                    });
                }
            }
            // }
            // this.model.photos = tmp
        },
        removeImage(index) {
            this.$refs.imageInput.value=null;
            // this.$refs[`photo-${index}`].reset();
            // this.$refs[`photo-${index}`][0].value='lalala';
            // this.model.photos.splice(index, 1)
            this.photos.splice(index, 1)
            this.photosFile.splice(index, 1)
            // this.imagesTarget.splice(index, 1)
        },
        async faceModal(open = true, index = null) {
            // hide scroll bar if true
            if(open) {
                EventEmit.$emit('overflowHidden', true);
                this.selectFaceModal = true
            } else {
                await this.removeImage(this.photoIndex)
                EventEmit.$emit('overflowHidden', false);
                this.faceDetected = []
                this.selectFaceModal = false
                this.faceSelected = null
            }
            this.photoIndex = index
        },
            // this.removeImage(index)
        async selectFace(index) {
            console.log('selectFace(index)', index);
            this.faceSelected = index;
        },
        urltoFile(url, filename, mimeType){
            return (fetch(url)
                .then(function(res){return res.arrayBuffer();})
                .then(function(buf){return new File([buf], filename,{type:mimeType});})
            );
        },
        async selectAction() {
            var files = this.faceDetected[this.faceSelected]
            // console.log(files)
            if (!files) return;
            // console.log({files})
            this.ignoreFaceDetect = true
            await this.faceModal(false);
            const self = this
            await this.urltoFile(files, 'face.jpg', "image/jpeg").then((fileResult)=>{ 
            // await this.urltoFile(files).then((fileResult)=>{ 
                // console.log({fileResult});
                // self.imgSrc = ''
                self.createImage(fileResult);
            });
            // this.imgSrc = '';
            // await this.createImage(files);
        },
        // END FILE UPLOAD

        reset() {
            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset form?',
                // text: id,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    if (this.route_name === 'PageTargetCreate') {
                        this.target_name = '';
                        this.clues = [];
                        this.label = '';
                        // this.status = '';
                        this.photo = '';
                        this.photos = [];
                        this.case_id = [];
                        this.description = '';
                        this.additional_info = [];

                        this.photoFile = '';
                        this.photosFile = [];
                        this.clueNameTmp = '';
                        this.clueValTmp = '';
                        this.infoNameTmp = '';
                        this.infoValTmp = '';

                        this.error_target_name = '';
                        this.error_clues = '';
                        this.error_label = '';
                        // this.error_status = '';
                        this.error_photo = '';
                        this.error_case_id = '';
                        this.error_description = '';
                        this.error_additional_info = '';
                    } else {
                        this.getData();
                    }
                }
            });
        },
        submit(e, save_continue=false){
            e.preventDefault();
            // console.log('=================== submit() route on roles form')
            // console.log(e);

            // console.log([this.target_name, this.clues, this.case_id, this.status, this.description]);
            // this.getData();

            this.showLoading(true);

            this.error_target_name = '';
            this.error_clues = '';
            this.error_label = '';
            // this.error_status = '';
            this.error_photo = '';
            this.error_case_id = '';
            this.error_description = '';
            this.error_additional_info = '';

            // console.log(this.clues.length)


            // validation
            if (this.target_name.length==0 || this.label.length==0 || this.case_id.length==0 || this.clues.length==0) {//|| this.status.length==0) {

                this.error_target_name = (this.target_name.length==0 ? 'Field target name is required.' : '');
                this.error_label = (this.label.length==0 ? 'Field label is required.' : '');
                // this.error_status = (this.status.length==0 ? 'Field status is required.' : '');
                this.error_case_id = (this.case_id.length==0 ? 'Field operation name is required.' : '');
                this.error_clues = (this.clues.length==0 ? "Field target's clues is required." : '');


                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: "Target name, label, operation name, target's clues is required!",//+ (this.route_name === 'PageTargetCreate' ? ', status' : ', & status' ) +' is required!',
                    // timer: 3000,
                });

                return;
            }

            if (this.target_name.length>255) {

                this.error_target_name = (this.target_name.length>255 ? 'Field operation name is not more than 255 characters.' : '');

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data length is not more than 255 characters!',
                    text: 'Target name is not allowed more than 255 characters!',
                    // timer: 3000,
                });

                return;
            }

            if (this.route_name === 'PageTargetCreate') {
                var redirect = 'index'
                if (this.propTarget && this.propTarget.decrypt_data) {
                    this.$swal.fire({
                        icon: 'question',
                        title: 'Save and redirect to?',
                        // text: id,
                        confirmButtonText: 'Result',
                        confirmButtonColor: '#3085d6',
                        cancelButtonText: 'List Target',
                        cancelButtonColor: '#dd6b55',
                        showCancelButton: true,
                    })
                        .then((result) => {
                            if (result.isConfirmed) { 
                                redirect = 'result'
                                // this.processSearch(this.propTarget.decrypt_data.key, this.propTarget.decrypt_data.type)
                            } else {
                                redirect = 'index'
                                // this.$router.push('/target');
                            }
                            this.showLoading(true);
                            this.createProcess(save_continue, redirect);
                    })
                } else {
                    this.createProcess(save_continue, redirect);
                }
            // PageTargetEdit
            } else {

                // this.$store.dispatch('getSingleTargetUpdate', [this.id, this.target_name, [JSON.stringify(this.clues)], this.label, this.photoFile, [JSON.stringify(this.case_id)], this.description, [JSON.stringify(this.additional_info)]])// this.status,
                
                // with multiple photos
                this.$store.dispatch('getSingleTargetUpdateNew', [this.id, this.target_name, [JSON.stringify(this.clues)], this.label, this.photosFile, [JSON.stringify(this.case_id)], this.description, [JSON.stringify(this.additional_info)]])// this.status,
                .then((resp) => {
                    // console.log('update')
                    // console.log({resp})
                    if (resp.result === 'success') {
                        if (save_continue === false)
                            if (this.target_redirect !== 'index') {
                                var msisdn = this.checkMsisdn(this.clues)
                                if (msisdn.length > 0) {
                                    this.$router.push({ name: 'PageTargetDetailHome', params: { id: this.id ,key: encrypt(msisdn[0].value + '&&msisdn') }  })
                                } else {
                                    this.$router.push('/target');
                                }
                            } else {
                                this.$router.push('/target');
                            }
                            

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully updated!',
                            timer: 3000,
                        });
                    } else {
                        if (resp.data.message && resp.data.message.errors) {
                            this.error_target_name = (resp.data.message.errors.target_name ? resp.data.message.errors.target_name : '');
                            this.error_clues = (resp.data.message.errors.clues ? resp.data.message.errors.clues : '');
                            this.error_label = (resp.data.message.errors.label ? resp.data.message.errors.label : '');
                            // this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                            this.error_photo = (resp.data.message.errors.photo ? resp.data.message.errors.photo : '');
                            this.error_case_id = (resp.data.message.errors.case_id ? resp.data.message.errors.case_id : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');
                            this.error_additional_info = (resp.data.message.errors.additional_info ? resp.data.message.errors.additional_info : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });
            }
        },
        createProcess(save_continue, redirect){
            // this.$store.dispatch('getSingleTargetCreate', [this.target_name, [JSON.stringify(this.clues)], this.label, this.photoFile, [JSON.stringify(this.case_id)], this.description, [JSON.stringify(this.additional_info)]])//this.status,
            
            // with multiple photos
            this.$store.dispatch('getSingleTargetCreateNew', [this.target_name, [JSON.stringify(this.clues)], this.label, this.photosFile, [JSON.stringify(this.case_id)], this.description, [JSON.stringify(this.additional_info)]])//this.status,
            .then((resp) => {
                // console.log('create')
                // console.log({resp})
                if (resp.result === 'success') {
                    // this.$router.push({ name: 'PageTargetIndex' });
                    if (save_continue === false) {
                        if (redirect === 'result') {
                            this.$store.commit('setLoadDataStatusProfileSubheader', {cancel:null,status:false, code:null});
                            this.$store.commit('setLoadDataStatusProfileSubheaderName', {cancel:null,status:false, code:null});
                            this.processSearch(this.propTarget.decrypt_data.key, this.propTarget.decrypt_data.type)
                        } else {
                            this.$router.push('/target');
                        }
                    } else {
                        this.$router.push('/target/'+ resp.data.data.id +'/edit');
                    }

                    this.$swal.fire({
                        icon: 'success',
                        title: 'Data successfully created!',
                        timer: 3000,
                    });
                } else {
                    
                    if (resp.data.message && resp.data.message.errors) {
                        this.error_target_name = (resp.data.message.errors.target_name ? resp.data.message.errors.target_name : '');
                        this.error_clues = (resp.data.message.errors.clues ? resp.data.message.errors.clues : '');
                        this.error_label = (resp.data.message.errors.label ? resp.data.message.errors.label : '');
                        // this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                        this.error_photo = (resp.data.message.errors.photo ? resp.data.message.errors.photo : '');
                        this.error_case_id = (resp.data.message.errors.case_id ? resp.data.message.errors.case_id : '');
                        this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');
                        this.error_additional_info = (resp.data.message.errors.additional_info ? resp.data.message.errors.additional_info : '');

                        this.error(resp.data.message.errors);
                    } else {
                        this.error();
                    }
                }
            });
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    // errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: 'Something wrong.',
                html: errors,
                // timer: 3000
            });
        },
        selectLabel(key) {
            this.label = key
        },
        // updateCase(value, id) {
        //     // console.log(value)
        //     // console.log(id)
        //     if (this.case_id.includes(value[0].id)) {
        //         // console.log('delete')
        //         // console.log(value[0].id)
        //         this.case_id = this.case_id.filter(id => id !== value[0].id);
        //     } else {            
        //         // console.log('update')
        //         // console.log(value[0].id)
        //         this.case_id.push({
        //             id: value[0].id
        //         })
        //     }
        // },
        addClue() {
            if (this.clueValTmp.length==0 || this.clueNameTmp.length==0) {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: 'Please fill in completely!',
                });

                return;
            }
            else {
                var isDuplicate = this.checkDuplicateClues(this.clueValTmp)
                if (isDuplicate) {
                    this.$swal.fire({
                        icon: 'warning',
                        title: 'Keyword already exist',
                        text: 'Please fill in different keyword!',
                    });
                } else {
                    var resetTmp = true
                    if (this.clueNameTmp == 'msisdn') {
                        // console.log((this.clueValTmp).substring(0, 3))
                        
                        if ((this.clueValTmp).substring(0, 3) == '628' || (this.clueValTmp).substring(0, 2) == '08') {
                            this.clues.push({
                                name: this.clueNameTmp,
                                value: this.clueValTmp,
                                detail: [
                                    {
                                        name: 'imsi',
                                        value: ''
                                    },
                                    {
                                        name: 'imei',
                                        value: ''
                                    },
                                ]
                            })
                        } else {                    
                            resetTmp = false
                            this.$swal.fire({
                                icon: 'warning',
                                title: 'Incorrect MSISDN format!',
                                text: 'MSISDN must start with 628 or 08',
                            });
                        }
                    } else {
                        this.clues.push({
                            name: this.clueNameTmp,
                            value: this.clueValTmp,
                            detail: []
                        })
                    }
                    if(resetTmp){                
                        this.clueNameTmp = ''
                        this.clueValTmp = ''
                    }
                }
            }
        },
        deleteClue(index) {
            this.clues.splice(index, 1);
        },
        checkDuplicateClues(key) {
            var found = false;
            for(var i = 0; i < this.clues.length; i++) {
                if (this.clues[i].value == key) {
                    found = true;
                    break;
                }
                if (this.clues[i].detail != undefined) {
                    for(var j = 0; j < this.clues[i].detail.length; j++) {
                        if (this.clues[i].detail[j].value == key) {
                            found = true;
                            break;
                        }
                    }
                }
            }
            return found
        },
        addInfo() {
            if (this.infoValTmp.length==0 || this.infoNameTmp.length==0) {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Data is required!',
                    text: 'Please fill in completely!',
                });

                return;
            }
            else {            
                this.additional_info.push({
                    name: this.infoNameTmp,
                    value: this.infoValTmp
                })
                this.infoNameTmp = ''
                this.infoValTmp = ''
            }
        },
        deleteInfo(index) {
            this.additional_info.splice(index, 1);
        }
    },
    created(){
        Promise.all([
            faceapi.nets.ssdMobilenetv1.loadFromUri('/weight'),
            faceapi.nets.faceLandmark68Net.loadFromUri('/weight'),
            faceapi.nets.faceRecognitionNet.loadFromUri('/weight')
        ]).then(async () => {
            this.faceapiLoaded = true
        })
    },
    mounted() {
        // console.log('=================== mounted on single target form')
        this.getData();
        // console.log('this.propTarget')
        // console.log(this.propTarget)
        if (this.propTarget) {
            if (this.propTarget.clues) {
                // console.log('masuk clues')
                this.clues.push(this.propTarget.clues)
            }
            if (this.propTarget.target_name) {
                // console.log('masuk target_name')
                this.target_name = this.propTarget.target_name
            }
        }
        // console.log('this.clues')
        // console.log(this.clues)
        // console.log('this.target_name')
        // console.log(this.target_name)
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="sass">
    .box-photo-container
        .box-photo
            &__item
                position: relative
                display: block
                width: 100%
                padding-bottom: 100%

                .item-photo
                    position: absolute
                    left: 0
                    top: 0
                    right: 0
                    bottom: 0
                    width: 100%
                    height: 100%
                    

                    &:hover
                        .btn-delete
                            opacity: 1
                    .btn-delete
                        position: absolute
                        top: 0
                        right: 0
                        margin-right: 1em
                        margin-top: 1em
                        opacity: 0
                    .added-photo
                        position: absolute
                        left: 0
                        top: 0
                        right: 0
                        bottom: 0
                        width: 100%
                        height: 100%
                        display: flex
                        justify-content: center
                        align-items: center
                        text-align: center
                        &:hover
                            background-color: #000
                        &__input
                            input
                                position: absolute
                                left: 0
                                top: 0
                                right: 0
                                bottom: 0
                                width: 100%
                                height: 100%
                                opacity: 0
                                cursor: pointer
        //                         z-index: 10
        .box-photo
            &__item
                position: relative
                display: block
                width: 100%
                padding-bottom: 100%

                .item-photo
                    @apply .absolute .inset-0 .w-full .h-full
                    &:hover
                        .btn-delete
                            @apply .opacity-100
                    
                    .btn-delete
                        @apply .absolute .right-0 .top-0 .mr-1 .mt-1 .opacity-0
                    .added-photo
                        &:hover
                            @apply .bg-black
                        @apply .absolute .inset-0 .w-full .h-full .flex .items-center .justify-center
                        &__input
                            input
                                @apply .absolute .inset-0 .w-full .h-full .opacity-0 .cursor-pointer .z-10

        .cta-select
            position: relative
            &:hover
                background-color: #000
            &__input
                input
                    position: absolute
                    left: 0
                    top: 0
                    right: 0
                    bottom: 0
                    width: 100%
                    height: 100%
                    opacity: 0
                    cursor: pointer
                    z-index: 10

    .object-cover
        object-fit: contain
        background-color: #040512
    

    .box-object
        display: flex
        align-items: center
        margin-top: 12px
        flex-wrap: wrap
        .list-object
            flex: 0 0 calc( 100% / 3 )
            img
                width: 100%
                height: 180px
                overflow: hidden
                object-fit: contain
                // object-fit: cover
                border: 4px solid transparent
                &:hover
                    opacity: 0.8
            &--active
                img
                    border-color: #70F2A1
                    &:hover
                        opacity: 1
</style>


<style>
    canvas{position: absolute}
</style>